import {Props} from "./view.types";
import React from "react";
import './view.styles.css'

const FilmReviewCard = ({film, onChangeNewFolder, newFolder}: Props) => {
    return (
        <div className={'film_review_card_container'}>
            <img className={'bgimage'} alt={'bg_image'} src={film.image_url || film.pending_data?.imdbId?.image} referrerPolicy="no-referrer"/>
            <div className={'data_container'}>
                <div className={'source'}>{film.pending_data ? "pending" : `db (${film.id})`}</div>
                <div className={'space'}/>
                <div className={'title_container'}><span className={'text title'}>{film.main_title}</span> <span className={'text year'}>({film.year})</span></div>
                <div className={'data'}>
                    <div className={'data_row folder'}>
                        <span className={'text'}>{film.folder}</span>
                        <input className={'new_folder'} type={'text'} maxLength={4} value={film.newFolder || newFolder} onChange={(event) => {
                            onChangeNewFolder(event.target.value)
                        }}/>
                    </div>
                    <div className={'data_row text extension'}>{film.format}</div>
                    <div className={'data_row text size'}>{film.size}</div>
                    <div className={'data_row text langs'}>{(film.languages || []).join(',')}</div>
                    <div className={'data_row text subs'}>{(film.subtitles || []).join(',')}</div>
                    <div className={'data_row text imdb_id'}>{film.imdb_id}</div>
                    <div className={'data_row text filmaffinity_id'}>{film.filmaffinity_id}</div>
                    <div className={'filename data_row text'}>{film.file_name}</div>
                </div>
            </div>
        </div>
    )
}

export default FilmReviewCard
